
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { LeftPanelService } from '../services/left-panel.service';
import { UserService } from '../../../core/security/user.service';
import { NavigationService } from '../../../core/navigation.service';
import { AlertService, LoggerService, ResourceService } from 'sce-core';
import { ConfirmDialogService } from 'sce-core';
import { saveAs } from 'file-saver'; // Don't forget to import the file-saver
import { HelpPopupComponent } from '../help-popup/help-popup.component';
import { SharedServiceRegistry } from '../../../shared/shared-service-registry';
import { ReceiptDataService } from '../../../shared/services/receipt/receipt-data.service';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserPreferenceService } from '../services/user-preference.service';
import { of } from 'rxjs/observable/of';

@Component({
  selector: 'lfwms-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
  animations: [
    trigger('openClose', [
      state('open', style({
        right: '350px',
      })),
      state('closed', style({
        right: '12px'
      })),
      transition('open => closed', [
        animate('0.5s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ])
  ]
})
export class ProfileComponent implements OnInit,AfterViewInit {

  public displayName: string;
  public displayCountry: any = {};
  public displayLanguage: any = {};
  public show: boolean = false;
  public cntryDropDownShow: boolean;
  public langDropDownShow: boolean;
  public image_user = 'assets/images/icon-person.png';
  public displayPhotoBool: boolean = false;

  public countries: any[];
  public  languages: any[];
  private storers: any[];
  private selectedCountry: number;
  private selectedLanguage: number;
  private selectedStorer: string;
  private showErrorLog: boolean;
  public tooltipPosition: string = 'left';
  public tooltipMessageServerName: string = 'Server Name';
  public tooltipMessageDBName: string = 'DB Name';

  protected dataService: ReceiptDataService;
  stateCtrl: FormControl = new FormControl();
   filteredStates: Observable<string[]>;
 
   searchControl = new FormControl();
   private readonly searchSubject = new BehaviorSubject<any>({});
   suggestions: Observable<any[]>;
   @ViewChild('searchInput') searchInput: ElementRef;
   private originalPlaceholder: string;

  ngAfterViewInit() {
    const inputEl = this.searchInput.nativeElement as HTMLInputElement;
    this.originalPlaceholder = inputEl.placeholder; // store initial value
  }

  constructor(private userService: UserService,
    private navService: NavigationService,
    private confirmDialogService: ConfirmDialogService,
    private resourceService: ResourceService,
    public leftPanelService: LeftPanelService,
    public loggerService: LoggerService,
    public alertService: AlertService,
    public userPref:UserPreferenceService,
    protected sharedServiceRegistry: SharedServiceRegistry) {
  }
 onMenuSelect(event: any) {
    this.navService.navigateByMenuId(event.option.value.menuID);
    this.searchControl.setValue('');
  }
  // method used to translate the labels
  public getLabel(key: any) {
    return this.resourceService.get(key);
  }
clearSearch() {
  this.searchControl.setValue('');
}

  public ngOnInit() {
    this.getDbServerDetails();
    this.updateUserPreference();
    this.displayName = this.userService.userInfo.displayName;
    this.suggestions = this.searchControl.valueChanges
    .debounceTime(300)
    .distinctUntilChanged()
    .startWith('')
    .switchMap((term: string) => {
        if (term && term.length >= 1) {
           return this.userPref.autoSuggest(term)
          .map((results: any[]) => results.map(user => ({
            ...user,
            highlightedValue: user.displayValue
          })));
        } else {
          return of([]);
        }
    });
    this.searchControl.valueChanges.subscribe(value => {
      this.searchSubject.next(value);
    });
    if (this.userService.userInfo.photo) {
    this.image_user = this.userService.userInfo.photo;
    this.displayPhotoBool = true;
    }
    //to logout from all tabs
    this.listenForLogout();
  }
  // Logs the user out
  public logout() {
    if (this.navService.preventNavigation) {
      const dialogMsg = [`<b>` + this.resourceService.get('mn_data_lost_msg') + `</b>`, this.resourceService.get('mn_nav_confirm_msg')];
      this.confirmDialogService.confirmDialog(this.resourceService.get(dialogMsg)).subscribe((isConfirmed) => {
        if (!isConfirmed) {
          return false;
        }
        this.navService.preventNavigation = false;
        this.userService.logout();
        localStorage.setItem('logout', String(Date.now())); 

       });
      return;
    }
    // else
    this.userService.logout();
    localStorage.setItem('logout', String(Date.now())); 
  }
  onFocus() {
    const inputEl = this.searchInput.nativeElement as HTMLInputElement;
    inputEl.placeholder = '';
  }

  onBlur() {
    const inputEl = this.searchInput.nativeElement as HTMLInputElement;

    // only restore if nothing typed
    if (!inputEl.value) {
      inputEl.placeholder = this.originalPlaceholder;
    }
  }
  /* Save the selected language to backend.
    this.saveCntryLang() reloads homepage */
  private saveLang(language: any) {
    if (this.navService.preventNavigation) {
      const dialogMsg = [`<b>` + this.resourceService.get('mn_data_lost_msg') + `</b>`, this.resourceService.get('mn_nav_confirm_msg')];
      this.confirmDialogService.confirmDialog(this.resourceService.get(dialogMsg)).subscribe((isConfirmed) => {
        if (!isConfirmed) {
          return false;
        }
        this.navService.preventNavigation = false;
        this.selectedLanguage = language.languageId;
        this.displayLanguage = language;
        this.saveCntryLang();

       });
      return;
    }
    // else
    this.selectedLanguage = language.languageId;
    this.displayLanguage = language;
    this.saveCntryLang();
  }

  /* Save the selected country to backend.
    this.saveCntryLang() reloads homepage */
  private saveCntry(country: any) {
    if (this.navService.preventNavigation) {
      const dialogMsg = [`<b>` + this.resourceService.get('mn_data_lost_msg') + `</b>`, this.resourceService.get('mn_nav_confirm_msg')];
      this.confirmDialogService.confirmDialog(this.resourceService.get(dialogMsg)).subscribe((isConfirmed) => {
        if (!isConfirmed) {
          return false;
        }
        this.navService.preventNavigation = false;

          this.selectedCountry = country.countryId;
          this.displayCountry = country;
          this.saveCntryLang();

       });
      return;
    }
    // else
    this.selectedCountry = country.countryId;
    this.displayCountry = country;
    this.saveCntryLang();
  }

  /* This methods reads currently selected countryId and languageId
  and calls update preferences method for the user.
  Once save call is successfull it reloads homepage.*/
  private saveCntryLang() {
   // this.selectedLanguage = Number(this.selectedLanguage);
    this.userService.updatePreferences(
      this.selectedCountry,
      this.selectedLanguage)
      .subscribe(() => this.reloadWindow());
  }
   /*  This function fetches and sets Country list and Language list
    for use in Cntry/Lang change dropdowns */
  private retrieveCountryLangList() {
    this.userService.getEnabledCountries()
      .subscribe((data: any) => {
        this.countries = data;
        this.countries = this.countries.filter((cntry: any) => {
          return cntry.countryId !== this.userService.userInfo.defaultCountry;
        });
        for (const country of data) {
          if (country.countryId === this.userService.userInfo.defaultCountry) {
            this.displayCountry = country;
            break;
          }
        }
      });
    this.userService.getAllLanguages()
      .subscribe((data: any) => {
        this.languages = data;
        this.languages = this.languages.filter((lang: any) => {
          return lang.languageId !== this.userService.userInfo.defaultLanguage;
        });
        for (const language of data) {
          if (language.languageId === this.userService.userInfo.defaultLanguage) {
            this.displayLanguage = language;
            break;
          }
        }
      });
    this.selectedCountry = this.userService.userInfo.defaultCountry;
    this.selectedLanguage = this.userService.userInfo.defaultLanguage;
    this.storers = ['NIKE', 'nike1'];
    this.selectedStorer = 'NIKE';
    // this.userService.userInfo.userRestrictions
  }
  public updateUserPreference(){
    this.userService.getUserPreferences()
    .subscribe((data: any) => {
      if(data.defaultCountryId != this.userService.userInfo.defaultCountry ){
        this.selectedCountry = data.defaultCountryId;
        this.selectedLanguage = data.defaultLanguageId;
        this.saveCntryLang();
      } else {
        this.retrieveCountryLangList();
      }
    });
  }
  public downloadErrorLog() {
    let log  = this.loggerService.errorLog.toString();
    if(log === ""){
      this.alertService.clearAll().warn(this.resourceService.translateServerResponse("msg_error_log"));
    } else {
      saveAs(new Blob([log], { type: "text" }), 'error.log');
    }
    // this.loggerService.errorLog = [];

  }

  public getDbServerDetails() {
    this.userService.getDbDetails()
    .subscribe((data: any) => {
      if (data && data.database && data.server) {
        this.tooltipMessageServerName = data.server;
        this.tooltipMessageDBName = data.database;
      }
    });
  }

  public helpPopup() {
    this.alertService.clearAll();
    const modalRef: any = this.sharedServiceRegistry.sceModalService
      .showModal(HelpPopupComponent,
        {
          overlayHeader: 'Help',
          showHeader: true,
          overlayHeight: 520,
          overlayWidth: 840
        });
        modalRef.content.initialize();
    // modalRef.content.showLookup = true;
  }

  private listenForLogout() {
    const LOGOUT_KEY = 'logout';
    window.addEventListener('storage', (event) => {
      if (event.key === LOGOUT_KEY) {
        this.userService.logout();
        localStorage.removeItem(LOGOUT_KEY); // Clean up the storage key
      }
    });
  }

  protected reloadWindow(): void {
    window.location.reload();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/layout/home/profile/profile.component.ts